import { render } from "./AppNav.vue?vue&type=template&id=f3e7e07c"
import script from "./AppNav.vue?vue&type=script&lang=js"
export * from "./AppNav.vue?vue&type=script&lang=js"
script.render = render

export default script